import { render } from "./banner.vue?vue&type=template&id=7c170490"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=7c170490&lang=scss"

import exportComponent from "/chaopin/jpom/data/build/66617637594a40d3882f98d9518ea655/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__